import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.js";
import { applyStoredAppearance } from "./lib/theme.js";
import "./styles.css";

// Apply the user's stored theme + font size before React mounts so every
// route — not just /settings — sees the right appearance from the first paint.
// (The inline script in index.html already handles light/dark for the very
// first paint; this call attaches the prefers-color-scheme listener for
// "auto" and keeps the React tree's source-of-truth in sync.)
applyStoredAppearance();

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1 } } });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
